var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncompass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 268,
    height: 55.205,
    viewBox: "0 0 268 55.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 268,
    height: 55.205,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M84.855,17.819q1.113,0,1.113,1.293t-.98,8.69q-1.871,13.908-1.982,14.78a.856.856,0,0,1-.914.866H80.041l-.223,1.338h10.3l.222-1.338H88.02c-.743,0-1.113-.428-1.113-1.291q0-1.117,1.024-8.693Q89.4,22.544,89.89,18.622a.806.806,0,0,1,.894-.8h2.048l.225-1.338h-10.3l-.221,1.338Z",
    transform: "translate(-10.815 -2.233)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M101.453,42.192a23.83,23.83,0,0,1,3.611-9.985q2.229-3.254,3.923-3.254,1.38,0,1.381,2.54,0,1.2-.736,7.021t-.736,6.174q0,1.919.893,1.918a7.905,7.905,0,0,0,2.585-.625,13.79,13.79,0,0,0,4.1-2.451l-.4-.847a8.365,8.365,0,0,1-3.12,1.515c-.388,0-.58-.386-.58-1.159q0-.313.736-5.573a63.539,63.539,0,0,0,.733-7.087q0-4.1-3.073-4.1-2.141,0-4.858,3.165a21.4,21.4,0,0,0-3.389,5.3l-.178-.089a58.808,58.808,0,0,0,.98-7.489c0-.594-.15-.891-.445-.891a11.191,11.191,0,0,0-2.987.578,13.546,13.546,0,0,0-3.833,1.784l.357.891a6.769,6.769,0,0,1,2.719-1.116c.386,0,.58.491.58,1.471q-.8,7.891-2.23,16.226h3.387Z",
    transform: "translate(-13.016 -3.561)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M130.582,45.135q-3.923,0-3.922-5.974a16.094,16.094,0,0,1,1.56-7.132q1.828-3.877,5.126-4.547a3.578,3.578,0,0,0,3.031,1.739c1.041,0,1.56-.384,1.56-1.158q0-.891-1.425-1.382a5.973,5.973,0,0,0-2.1-.4q-4.323,0-7.934,4.189a14.16,14.16,0,0,0-3.612,9.495q0,7,6.152,7a10.6,10.6,0,0,0,4.458-1.024,10.786,10.786,0,0,0,3.7-2.72l-.622-.8a8.321,8.321,0,0,1-5.974,2.718",
    transform: "translate(-16.649 -3.561)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M148.849,31.983q1.828-4.367,5.127-4.367,3.653,0,3.653,6.463a18.412,18.412,0,0,1-1.38,7.176q-1.828,4.367-5.127,4.369-3.656,0-3.653-6.465a18.391,18.391,0,0,1,1.38-7.177m-3.365,13.128a5.712,5.712,0,0,0,4.525,1.851q4.457,0,7.845-4.147a15.081,15.081,0,0,0,3.387-9.849,7.054,7.054,0,0,0-1.627-4.837,5.712,5.712,0,0,0-4.525-1.851q-4.456,0-7.845,4.147a15.084,15.084,0,0,0-3.387,9.85,7.053,7.053,0,0,0,1.627,4.836",
    transform: "translate(-19.492 -3.561)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M169.774,28.419q.58,0,.58,1.471-.8,7.891-2.23,16.226h3.387l.58-3.922a23.824,23.824,0,0,1,3.612-9.986q2.228-3.252,3.922-3.253,1.246,0,1.247,2.451,0,1.516-1.872,14.71h3.387l.491-3.611a24.178,24.178,0,0,1,2.318-7.845,16.036,16.036,0,0,1,3.076-4.367q1.425-1.34,2.094-1.337,1.382,0,1.382,2.54,0,1.2-.736,7.021t-.736,6.174q0,1.915.891,1.916a7.9,7.9,0,0,0,2.587-.625,13.757,13.757,0,0,0,4.1-2.451l-.4-.847a8.348,8.348,0,0,1-3.12,1.516q-.58,0-.578-1.158,0-.313.736-5.572a63.58,63.58,0,0,0,.736-7.087,4.94,4.94,0,0,0-.825-2.964,2.481,2.481,0,0,0-2.073-1.139q-2.228,0-4.994,3.165a21.545,21.545,0,0,0-3.386,5.305l-.178-.089q.267-4.947.266-4.278a4.934,4.934,0,0,0-.824-2.964,2.477,2.477,0,0,0-2.072-1.139q-1.963,0-4.635,3.165a21.464,21.464,0,0,0-3.345,5.305l-.178-.089a58.758,58.758,0,0,0,.98-7.49c0-.592-.148-.891-.444-.891a11.167,11.167,0,0,0-2.987.58,13.517,13.517,0,0,0-3.834,1.783l.358.891a6.745,6.745,0,0,1,2.718-1.113",
    transform: "translate(-22.587 -3.561)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M207.931,28.417c.386,0,.58.492.58,1.471q0,.8-1.6,12.795Q205.436,54,205.122,55.831c-.059.386-.356.58-.89.58h-1.115l-.222,1.2h10.252l.222-1.2h-3.523q-1.113,0-1.113-1.293,0-.134.936-8.157h1.159a12.309,12.309,0,0,0,9.45-4.325,14.144,14.144,0,0,0,3.79-9.805,9.618,9.618,0,0,0-.894-4.414,3.6,3.6,0,0,0-3.387-2.138q-2.54,0-4.947,2.718a17.981,17.981,0,0,0-3.254,5.081h-.178a41.441,41.441,0,0,0,.711-6.907c0-.594-.147-.891-.444-.891a11.116,11.116,0,0,0-2.987.578,13.552,13.552,0,0,0-3.834,1.784l.358.891a6.741,6.741,0,0,1,2.718-1.116m10.119.536q1.337,0,1.962,1.738a7.567,7.567,0,0,1,.444,2.721q0,5.883-3.12,9.4a7.587,7.587,0,0,1-5.661,2.941,6.824,6.824,0,0,1-1.829-.222q1.074-7.4,2.141-9.85,2.9-6.733,6.063-6.732",
    transform: "translate(-27.492 -3.561)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M233.885,39.868a14.532,14.532,0,0,1,2.585-8.692,7.852,7.852,0,0,1,6.64-3.609,3.182,3.182,0,0,1,1.338.266l-.58,4.145q-.847,6.2-3.521,9.583-2.006,2.586-4.011,2.587-2.452,0-2.451-4.28m12.748,4.547q-.625,0-.581-1.158a100.083,100.083,0,0,1,2.275-18.009,3.259,3.259,0,0,0-1.382.29q-.267.2-.268,1.091a24.99,24.99,0,0,0-3.519-.266,11.813,11.813,0,0,0-9.184,4.457,15.01,15.01,0,0,0-3.7,9.984,7.883,7.883,0,0,0,.979,4.011,3.629,3.629,0,0,0,3.3,2.007q2.546,0,5.038-2.718a18.332,18.332,0,0,0,3.3-5.082h.088a44.492,44.492,0,0,0-.4,5.883q0,1.918.891,1.917a7.9,7.9,0,0,0,2.584-.624,13.808,13.808,0,0,0,4.1-2.452l-.4-.846a8.351,8.351,0,0,1-3.119,1.515",
    transform: "translate(-31.201 -3.421)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M267.756,26.68a7.592,7.592,0,0,0-2.5-.4,8.773,8.773,0,0,0-5.038,1.515,5.063,5.063,0,0,0-2.5,4.325,5.266,5.266,0,0,0,2.007,3.744q1.871,1.516,3.745,3.074,2,1.786,2,3.345a3.085,3.085,0,0,1-1.136,2.585,4.517,4.517,0,0,1-2.875.891,2.683,2.683,0,0,1-1.293-.311q-.892-2.495-2.941-2.5c-.893,0-1.337.386-1.337,1.158q0,1.428,2.185,2.23a9.5,9.5,0,0,0,3.387.624,9.145,9.145,0,0,0,4.947-1.426,4.876,4.876,0,0,0,2.542-4.189,6.124,6.124,0,0,0-2.1-4.414q-1.961-1.516-3.878-2.987-2.094-1.695-2.1-3.165a2.9,2.9,0,0,1,.935-2.185,4.647,4.647,0,0,1,3.345-1.113,2.719,2.719,0,0,0,2.763,2.007q1.469,0,1.471-1.159,0-1.071-1.649-1.649",
    transform: "translate(-34.674 -3.561)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M286.834,26.68a7.592,7.592,0,0,0-2.5-.4,8.773,8.773,0,0,0-5.038,1.515,5.063,5.063,0,0,0-2.5,4.325,5.266,5.266,0,0,0,2.007,3.744q1.871,1.516,3.743,3.074,2.006,1.786,2.007,3.345a3.085,3.085,0,0,1-1.136,2.585,4.522,4.522,0,0,1-2.875.891,2.683,2.683,0,0,1-1.293-.311q-.892-2.495-2.941-2.5c-.893,0-1.337.386-1.337,1.158q0,1.428,2.185,2.23a9.5,9.5,0,0,0,3.387.624,9.149,9.149,0,0,0,4.948-1.426,4.877,4.877,0,0,0,2.542-4.189,6.124,6.124,0,0,0-2.1-4.414q-1.961-1.516-3.878-2.987-2.094-1.695-2.1-3.165A2.9,2.9,0,0,1,280.9,28.6a4.647,4.647,0,0,1,3.345-1.113,2.719,2.719,0,0,0,2.763,2.007q1.471,0,1.471-1.159,0-1.071-1.649-1.649",
    transform: "translate(-37.259 -3.561)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M298.772,26.475h-.744V20.732H296V20.07h4.8v.661h-2.029Z",
    transform: "translate(-40.107 -2.72)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M305.5,26.474,303.329,20.8H303.3c.039.45.06.984.06,1.6v4.074h-.688v-6.4h1.12l2.029,5.283h.035L307.9,20.07h1.113v6.4h-.744V22.347q0-.708.061-1.541h-.035L306.1,26.474Z",
    transform: "translate(-41.011 -2.72)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M53.1,27.995a25.1,25.1,0,1,0-25.1,25.1,25.1,25.1,0,0,0,25.1-25.1",
    transform: "translate(-0.392 -0.392)",
    fill: "#007d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M46.9,45.745a25.1,25.1,0,0,0-35.5-35.5Z",
    transform: "translate(-1.544 -0.392)",
    fill: "#0a563d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M50.337,28.508a21.829,21.829,0,1,0-21.83,21.83A21.829,21.829,0,0,0,50.337,28.508Z",
    transform: "translate(-0.905 -0.905)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.248
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M54.126,1.081h0m0,0L32.3,32.3,1.081,54.126,22.908,22.909,54.126,1.081m0-1.081c-.029,0-.056,0-.085,0A1.066,1.066,0,0,0,53.5.2L22.29,22.024a1.053,1.053,0,0,0-.265.267L.2,53.506a1.081,1.081,0,0,0,1.5,1.506l31.217-21.83a1.047,1.047,0,0,0,.265-.266L54.988,1.732A1.08,1.08,0,0,0,54.133,0Zm0,2.16h0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M26.5,23.079,57.717,1.249,35.887,32.467Z",
    transform: "translate(-3.591 -0.169)",
    fill: "#eeb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M32.466,35.888,1.249,57.718,23.078,26.5Z",
    transform: "translate(-0.169 -3.591)",
    fill: "#cc950e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompass);
export default __webpack_public_path__ + "static/media/incompass.6362d8a120c7084e517368efff6a8ea4.svg";
export { ForwardRef as ReactComponent };